import React, { useState } from "react";
import {
  Box,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Divider,
  IconButton,
  Tooltip,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import HomeIcon from "@mui/icons-material/Home";
import PeopleIcon from "@mui/icons-material/People";
import PaymentIcon from "@mui/icons-material/Payment";
import ListAltIcon from "@mui/icons-material/ListAlt";
import SettingsIcon from "@mui/icons-material/Settings";
import HelpIcon from "@mui/icons-material/Help";
import LogoutIcon from "@mui/icons-material/Logout";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import { useNavigate, useLocation } from "react-router-dom";

const Sidebar = () => {
  const userData = JSON.parse(localStorage.getItem("user"));
  const navigate = useNavigate();
  const location = useLocation();
  const [collapsed, setCollapsed] = useState(false);

  const topMenu = [
    { text: "Anasayfa", icon: <HomeIcon />, path: "/anasayfa" },
    { text: "Personel", icon: <PeopleIcon />, path: "/personel" },
    { text: "Puantaj", icon: <PaymentIcon />, path: "/puantaj" },
    { text: "Departman/Pozisyon", icon: <ListAltIcon />, path: "/islemler" },
    { text: "Kurumlar", icon: <ListAltIcon />, path: "/eklemeler" },
    { text: "Dosyalar", icon: <AttachFileIcon />, path: "/dosyalar" },
  ];

  const bottomMenu = [
    { text: "Ayarlar", icon: <SettingsIcon />, path: "/ayarlar" },
    { text: "Yardım & Destek", icon: <HelpIcon />, path: "/yardim-destek" },
    { text: "Çıkış Yap", icon: <LogoutIcon />, path: "/logout" },
  ];

  // Üst Menü Filtreleme
  const visibleTopMenu = topMenu.filter((item) => {
    if (!userData) return true;

    if (userData.type === "kurum") {
      return !["Departman/Pozisyon", "Kurumlar"].includes(item.text);
    }

    if (userData.type === "personel") {
      return ["Dosyalar"].includes(item.text);
    }

    return true; // admin
  });

  const visibleBottomMenu = bottomMenu.filter((item) => {
    if (!userData) return true;
    if (["kurum", "personel"].includes(userData.type)) {
      return item.text !== "Ayarlar";
    }
    return true;
  });

  return (
    <Box
      sx={{
        width: collapsed ? 70 : 250,
        height: "100vh",
        bgcolor: "white",
        color: "black",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        boxShadow: "2px 0 5px rgba(0,0,0,0.1)",
        transition: "width 0.3s ease",
      }}
    >
      {/* Üst Menü + Logo */}
      <Box>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: collapsed ? "center" : "space-between",
            px: collapsed ? 0 : 2,
            py: 1.5,
            height: "60px",
            borderBottom: "1px solid rgba(0,0,0,0.1)",
          }}
        >
          {!collapsed && (
            <Box
              component="img"
              src="/images/logomy.png"
              alt="Logo"
              sx={{ height: 35, width: "auto", marginLeft: "20px" }}
            />
          )}
          <IconButton onClick={() => setCollapsed(!collapsed)}>
            <MenuIcon />
          </IconButton>
        </Box>

        <List>
          {visibleTopMenu.map((item) => {
            const isActive = location.pathname.startsWith(item.path);

            const buttonContent = (
              <ListItemButton
                key={item.text}
                onClick={() => navigate(item.path)}
                sx={{
                  minHeight: 40,
                  px: collapsed ? 1.5 : 2,
                  borderRadius: 2,
                  mx: 1,
                  my: 0.3,
                  bgcolor: isActive ? "#EFF6FF" : "transparent",
                  color: isActive ? "#1D4ED8" : "#4B5563",
                  "&:hover": {
                    bgcolor: isActive ? "#EFF6FF" : "rgba(0,0,0,0.05)",
                  },
                }}
              >
                <ListItemIcon
                  sx={{
                    color: isActive ? "#1D4ED8" : "gray",
                    minWidth: collapsed ? 0 : 36,
                    justifyContent: "center",
                  }}
                >
                  {item.icon}
                </ListItemIcon>
                {!collapsed && (
                  <ListItemText
                    primary={item.text}
                    primaryTypographyProps={{ fontSize: 14, ml: 0.5 }}
                  />
                )}
              </ListItemButton>
            );

            return collapsed ? (
              <Tooltip key={item.text} title={item.text} placement="right">
                {buttonContent}
              </Tooltip>
            ) : (
              buttonContent
            );
          })}
        </List>
      </Box>

      {/* Alt Menü */}
      <Box>
        <Divider sx={{ bgcolor: "rgba(0,0,0,0.1)" }} />
        <List>
          {visibleBottomMenu.map((item) => {
            const isActive = location.pathname.startsWith(item.path);

            const handleClick = () => {
              if (item.text === "Çıkış Yap") {
                localStorage.removeItem("user");
                navigate("/login");
              } else {
                navigate(item.path);
              }
            };

            const buttonContent = (
              <ListItemButton
                key={item.text}
                onClick={handleClick}
                sx={{
                  minHeight: 40,
                  px: collapsed ? 1.5 : 2,
                  borderRadius: 1,
                  mx: 1,
                  my: 0.3,
                  bgcolor: isActive ? "#EFF6FF" : "transparent",
                  color: isActive ? "#1D4ED8" : "#4B5563",
                  "&:hover": {
                    bgcolor: isActive ? "#EFF6FF" : "rgba(0,0,0,0.05)",
                  },
                }}
              >
                <ListItemIcon
                  sx={{
                    color: isActive ? "#1D4ED8" : "gray",
                    minWidth: collapsed ? 0 : 36,
                    justifyContent: "center",
                  }}
                >
                  {item.icon}
                </ListItemIcon>
                {!collapsed && (
                  <ListItemText
                    primary={item.text}
                    primaryTypographyProps={{ fontSize: 14, ml: 0.5 }}
                  />
                )}
              </ListItemButton>
            );

            return collapsed ? (
              <Tooltip key={item.text} title={item.text} placement="right">
                {buttonContent}
              </Tooltip>
            ) : (
              buttonContent
            );
          })}
        </List>
      </Box>
    </Box>
  );
};

export default Sidebar;